import { ReactNode, createContext, useContext } from 'react';

// Create a generic context factory
export function createContextFromValue<T>(contextName: string, defaultValue: T) {
    const Context = createContext<T>(defaultValue);

    const Provider = ({ children, value }: { children: ReactNode; value: T }) => {
        return <Context.Provider value={value}>{children}</Context.Provider>;
    };

    const useValue = (): T => {
        const context = useContext(Context);
        if (context === undefined) {
            throw new Error(`${contextName} hook must be used within its Provider`);
        }
        return context;
    };

    return { Provider, useValue };
}
